import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { i18n } from '../../translate/i18n';
import { useMetricsContext } from '../../context/Metrics/MetricsContext';

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.padding,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(2),
  },
}));

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      display: false,
    },
    title: {
      display: true,
      text: i18n.t('dashboard.charts.user.label'),
      position: 'left',
    },
    datalabels: {
      display: true,
      anchor: 'start',
      offset: -30,
      align: 'start',
      color: '#fff',
      textStrokeColor: '#000',
      textStrokeWidth: 2,
      font: {
        size: 20,
        weight: 'bold',
      },
    },
  },
};

export const ChatsUser = () => {
  // const classes = useStyles();

  // Usar o contexto unificado de métricas
  const { metrics, loading } = useMetricsContext();

  // Extrair dados de tickets por usuário do endpoint unificado
  const ticketsByUser = metrics?.ticketsByUser || [];

  const dataCharts = {
    labels:
      ticketsByUser.length > 0 ? ticketsByUser.map(item => item.nome) : [],
    datasets: [
      {
        data:
          ticketsByUser.length > 0
            ? ticketsByUser.map(item => item.quantidade)
            : [],
        backgroundColor: '#24B4A5',
        borderColor: 2
      },
    ],
  };

  return (
    <>
      <Typography component='h2' variant='h6' color='primary' gutterBottom>
        {i18n.t('dashboard.charts.user.title')}
      </Typography>

      <Bar
        options={options}
        data={dataCharts}
        style={{ maxWidth: '100%', maxHeight: '280px' }}
      />
    </>
  );
};
